module.exports = __webpack_public_path__ + "img/starter.42b36fe4.svg";